import { post } from 'features/api';
import { TriggerTrackingProductViewProps } from 'features/product-info/types';
import { runSaga } from 'redux-saga';
import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';
import { RootState } from 'typesafe-actions';
import { ApiRequestConfig } from '../../api';

export async function postAsync<Response = unknown, Data extends object = TriggerTrackingProductViewProps>(
  store: MiddlewareAPI<Dispatch<AnyAction>, RootState>,
  path: string,
  data: Data,
  config?: ApiRequestConfig,
) {
  return (await runSaga(
    {
      dispatch: (action: AnyAction) => store.dispatch(action),
      getState: () => store.getState(),
    },
    function* triggerTrackingProductView() {
      return yield* post(path, data, config);
    },
  ).toPromise()) as Promise<Response>;
}
